import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { formatCurrency } from '@/core/number';
import { getValueInUserLanguage } from '@/core/languageContent';
import { CustomerSubscription } from '@/modules/customer/CustomerSubscription';
import { Product, typeNames } from '@/modules/product/Product';
import AppButton from '@/core/components/form/AppButton.vue';
import CustomerFormSubscriptionForm from './CustomerFormSubscriptionForm.vue';
import FaIcon from '@/core/components/FaIcon.vue';

interface CustomerFormSubscriptionListProps {
	subscriptions: CustomerSubscription[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormSubscriptionList',
  props: {
    subscriptions: {}
  },
  emits: [
	'update:subscriptions',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const store = useStore<AppStore>();
const props = __props;
const emit = __emit;
const localSubscriptions = ref<CustomerSubscription[]>([]);
const editSubscription = ref<Partial<CustomerSubscription>| null>(null);
const products = computed<Product[]>(() => store.getters.products);
const getProductName = (id: number): string => {
	const product = products.value.find(p => p.id === id);
	if (!product) {
		return '-';
	}

	return getValueInUserLanguage(product.content) || '-';
};
const getTypeName = (id: number): string => {
	const product = products.value.find(p => p.id === id);
	if (!product) {
		return '-';
	}

	return typeNames[product.type];
};

const loadData = () => {
	localSubscriptions.value = props.subscriptions.map(subscription => Object.assign({}, subscription));
};
onBeforeMount(async () => {
	loadData();
	await store.dispatch('loadProducts');
});

watch(() => props.subscriptions, loadData);

const openNew = () => {
	editSubscription.value = {
		valid_from: new Date().toLocaleDateString('sv', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		}),
	};
};

const openEdit = (subscription: CustomerSubscription) => {
	editSubscription.value = subscription;
};

const subscriptionSaved = (newSubscription: CustomerSubscription) => {
	if (newSubscription.id) {
		const index = localSubscriptions.value.findIndex(s => s.id === newSubscription.id);
		localSubscriptions.value.splice(index, 1, newSubscription);
	} else {
		localSubscriptions.value.push(newSubscription);
	}

	emit('update:subscriptions', localSubscriptions.value);

	closeForm();
};

const closeForm = () => {
	editSubscription.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, [
      _createVNode(AppButton, {
        onClick: _withModifiers(openNew, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Nytt abonnemang/tillval", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("table", null, [
      _cache[7] || (_cache[7] = _createElementVNode("colgroup", null, [
        _createElementVNode("col"),
        _createElementVNode("col"),
        _createElementVNode("col", { style: {"width":"100px"} }),
        _createElementVNode("col", { style: {"width":"130px"} }),
        _createElementVNode("col", { style: {"width":"130px"} }),
        _createElementVNode("col", { style: {"width":"50px"} })
      ], -1)),
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _withDirectives((_openBlock(), _createElementBlock("th", null, [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Produkt", -1)
          ]))])), [
            [_directive_translate]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("th", null, [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Produkttyp", -1)
          ]))])), [
            [_directive_translate]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("th", null, [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Pris", -1)
          ]))])), [
            [_directive_translate]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("th", null, [...(_cache[4] || (_cache[4] = [
            _createTextVNode("Giltig från", -1)
          ]))])), [
            [_directive_translate]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("th", null, [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Giltig till", -1)
          ]))])), [
            [_directive_translate]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localSubscriptions.value, (subscription) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: subscription.id
          }, [
            _createElementVNode("td", null, _toDisplayString(getProductName(subscription.product.id)), 1),
            _createElementVNode("td", null, _toDisplayString(getTypeName(subscription.product.id)), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(formatCurrency)(subscription.price)), 1),
            _createElementVNode("td", null, _toDisplayString(subscription.valid_from), 1),
            _createElementVNode("td", null, _toDisplayString(subscription.valid_to), 1),
            _createElementVNode("td", null, [
              _createVNode(AppButton, {
                onClick: _withModifiers(($event: any) => (openEdit(subscription)), ["prevent"]),
                title: _unref($gettext)('Redigera'),
                class: "button-seamless"
              }, {
                default: _withCtx(() => [
                  _createVNode(FaIcon, {
                    weight: "s",
                    icon: "pencil-alt",
                    class: "t-warning"
                  })
                ]),
                _: 1
              }, 8, ["onClick", "title"])
            ])
          ]))
        }), 128))
      ])
    ]),
    (editSubscription.value !== null)
      ? (_openBlock(), _createBlock(CustomerFormSubscriptionForm, {
          key: 0,
          subscription: editSubscription.value,
          onSave: subscriptionSaved,
          onCancel: closeForm
        }, null, 8, ["subscription"]))
      : _createCommentVNode("", true)
  ]))
}
}

})